<div class="header-bar">
  <h1>Customer Sites</h1>
</div>
<div class="content-container" style="position: relative">
  <form (ngSubmit)="search()" style="width: 100%">
    <div class="flex flex-wrap filterPanel">
      <div class="flex-grow-1">
        <span class="md-inputfield filterItem">
          <input
            name="textSearch"
            type="text"
            pInputText
            [(ngModel)]="filterVal.filters.siteName.value"
          />
          <label>Name</label>
        </span>
      </div>
      <div
        class="flex-grow-1"
        style="margin-top: auto; margin-bottom: auto; line-height: 40px; text-align: center"
      >
        <p-checkbox
          id="excludeDisabled"
          name="excludeDisabled"
          [(ngModel)]="filterVal.filters.excludeDisabled.value"
          binary="true"
          label="Exclude Disable Sites"
        ></p-checkbox>
      </div>
      <div class="flex-shrink-1">
        <button pButton type="submit" label="Search"></button>
        <button
          pButton
          type="button"
          label="Clear"
          (click)="clearFilter(customerSitesTable)"
        ></button>
      </div>
    </div>
  </form>
  <div class="">
    <p-table
      #customerSitesTable
      [value]="page.items"
      [rows]="10"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20]"
      selectionMode="single"
      [(selection)]="selectedSites"
      [sortOrder]="-1"
      [lazy]="true"
      (onLazyLoad)="onGridLazyLoad($event)"
      [totalRecords]="page.total"
      [hidden]="!isLoaded || !hasResult"
      [responsive]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="siteName">Internal Site Name</th>
          <th pSortableColumn="businessName">Business Name</th>
          <th pSortableColumn="address1">Address Line 1</th>
          <th pSortableColumn="city">Town</th>
          <th pSortableColumn="postcode">Postcode</th>
          <th pSortableColumn="what3Words">What3Words</th>
          <th pSortableColumn="releaseCode">Release Code</th>
          <th>Disabled?</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item" (dblclick)="editSite(item)">
          <td>{{ item.siteName }}</td>
          <td>{{ item.businessName }}</td>
          <td>{{ item.address1 }}</td>
          <td>{{ item.city }}</td>
          <td>{{ item.postcode | postcode }}</td>
          <td class="break-word">{{ item.what3Words }}</td>
          <td>{{ item.releaseCode }}</td>
          <td>{{ item.disabled ? 'Yes' : 'No' }}</td>
        </tr>
      </ng-template>
    </p-table>
    <div *ngIf="!hasResult">
      <h2 style="text-align: center">No results found</h2>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-12">
        <button
          type="button"
          class="ui-button-danger btn-to-right"
          pButton
          icon="fa ui-icon-trash"
          (click)="Delete(selectedSites)"
          label="Delete"
          [disabled]="!selectedSites"
          *ngIf="hasResult"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          label="Edit"
          icon="fa ui-icon-mode-edit"
          [disabled]="!selectedSites"
          *ngIf="hasResult"
          (click)="editSite(selectedSites)"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          label="Add"
          (click)="editSite(null)"
        ></button>
      </div>
    </div>
  </div>
</div>

<app-customer-sites-editor
  [(visible)]="editorVisible"
  [site]="selectedSites ?? null"
  (updatedSite)="siteUpdated($event)"
  [source]="CustomerSiteEditorSource.SiteManager"
>
</app-customer-sites-editor>
